import { Project } from '../types'
import roles from './roles'

const speaking: Project[] = [
  {
    name: 'PAX West',
    date: new Date('Aug 1 2018'),
    role: roles.gameStartRole,
    slideIn: {
      text: `
      Presented on the development of a new gaming role in children's hospitals.
      `,
      collaborators: [
        'Travis Eriksen, Child’s Play', //Executive Director,
        'Micheal Kundrat, Children’s Hospital Colorado', //Gaming Technology Specialist,
        'Alexander Pereira, Methodist Children’s Hospital' //Gaming Technology Specialist,
      ]
    }
  },

  {
    name: 'PAX West',
    date: new Date('Aug 1 2017'),
    role: roles.gameStartRole,
    slideIn: {
      text: `
      Presented on how video games and XR can support health care.
      `,
      collaborators: [
        'Zach Wigal, Gamers Outreach', //Founder,
        'Aaron Greenberg, Xbox Games', //General Manager,
        'Carla Oliver, Childrens Hospital Colorado', //Child Life Director,
        'J.J. Bouchard, C.S. Mott Childrens Hospital',
        'Erick Blandon, Child’s Play' //Program Director,
      ]
    }
  },

  {
    name: 'SXSW',
    date: new Date('Mar 1 2017'),
    role: roles.gameStartRole,
    slideIn: {
      text: `
      Advocating VR and Gaming in Hospitals.
      `,
      collaborators: [
        'Erick Blandon, Child’s Play',
        'Bethany Folsom, C.S. Mott Childrens Hospital',
        'J.J. Bouchard, C.S. Mott Childrens Hospital'
      ]
    }
  },
  {
    name: 'MineCon',
    date: new Date('Sep 1 2016'),
    role: roles.gameStartRole,
    slideIn: {
      text: `
      Presented with Zach Wigal (founder of Gamers Outreach) on how Minecraft helps hospitalized children facing life-threatening illness.
      `
    }
  },
  {
    name: 'TEDx',
    date: new Date('Sep 1 2014'),
    role: roles.gameStartRole,
    slideIn: {
      externalLink: 'https://www.youtube.com/watch?v=rYCDaXgcKCA',
      text: `
      Presented the story of creating GameStart School at TEDxDetroit.
      `
    }
  }
]

export default speaking
